module.exports = __webpack_public_path__ + "img/cartas-silabas-directas.0dafb2ed.png";